<mat-nav-list class='nav-list'>
  <div class="nav-list-item" *ngFor="let link of links">
    <a class="nav-link" [routerLink]="link.anchor" [fragment]="link.fragment">{{link.text}}</a>
  </div>
</mat-nav-list>